var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AttributeCategorizedList',{attrs:{"attributes":_vm.attributes,"selectedEnvironment":_vm.selectedEnvironment,"categories":_vm.categories,"environments":_vm.environments}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }